import type { ProductCardDataType } from "packages/core-shopping/components/ProductCard/types";
import type {
  MultipleProductCard,
  SingularProductCard
} from "@shared/graphql.types";
import { isMultipleProductCard } from "./isMultipleProductCard";

export const toProductCardData = (
  productCard: MultipleProductCard | SingularProductCard,
  position = 0
): Omit<ProductCardDataType, "inWishlist"> => {
  let productCardData: Omit<ProductCardDataType, "inWishlist">;
  const variant = productCard.variants[position];
  const commonProductData = {
    id: productCard.id,
    buttonText: productCard.buttonText,
    brandName: productCard.brandName ?? undefined,
    productName: productCard.title,
    href: variant.href,
    inStock: variant.availability.inStock,
    primaryPrice: variant.pricing.primary.formatted,
    primaryPriceRaw: variant.pricing.primary.raw,
    primarySubtitle: variant.pricing.primary.label,
    secondaryPriceRaw: variant.pricing.secondary.raw,
    secondaryPrice: variant.pricing.secondary.formatted,
    secondarySubtitle: variant.pricing.secondary.label,
    rating: productCard.reviews.stars,
    reviewCount: productCard.reviews.count,
    badge: variant.badge
      ? {
          src: variant.badge.src,
          // TODO: description was changed updated from required to optional by CSE team
          alt: variant.badge.description ?? ""
        }
      : undefined,
    ribbon: variant.ribbon
      ? {
          ribbonKey: variant.ribbon.key,
          text: variant.ribbon.text
        }
      : undefined,
    image: {
      alt: productCard?.variants?.[position]?.images?.[0]?.altText ?? undefined,
      src: productCard?.variants?.[position]?.images?.[0]?.src
    },
    sku: variant.sku,
    variationName: variant.shade ?? "",
    highlightedPrice: productCard.highlightedPrice ?? "primary"
  };
  if (isMultipleProductCard(productCard)) {
    productCardData = {
      ...commonProductData,
      swatchImages: productCard.swatchImages ?? [],
      isPrimaryButtonDisabled: productCard.variants.every(
        (shadeVariant) => !shadeVariant.availability.inStock
      )
    };
    return productCardData;
  }
  return {
    ...commonProductData,
    isPrimaryButtonDisabled: !variant.availability.inStock
  };
};
